export { default as CachePersistor } from './CachePersistor';
export { default as persistCache } from './persistCache';
export * from './persistCacheSync';
//# sourceMappingURL=index.js.map